import { Breadcrumbs } from '../../../../core/components/organism/Breadcrumbs';
import Exercise from '../../../../core/components/templates/Exercise';
import Container from '../../../../core/components/atoms/Container';
import { useDisciplineExerciseHook } from '../../hooks/useExercise';
import ContentModal from '../../components/contentModal';
import Confetti from 'react-confetti';
import { useEffect } from 'react';
import { useUserStore } from '../../../Auth/stores/authStore';
import { validateLoadContent } from '../../../../core/utils/freeValidations';
import Lock from '../../../../core/components/organism/Lock';

const ExercisePage = () => {
  const { user } = useUserStore();

  const {
    slug,
    module,
    subject,
    exercises,
    isLoading,
    discipline,
    initialPage,
    isContentModal,
    breadcrumbItems,
    rightAnswer,
    updateExercise,
    changeExercise,
    setIsContentModal,
  } = useDisciplineExerciseHook();

  useEffect(() => {
    if (rightAnswer) {
      const audio = new Audio(
        'https://storage.aprovatotal.com.br/platform-storage-prod/sounds/songCorrectExercise.mp3'
      );
      if (user && user.exercisePlaySound) {
        audio.play();
      }
    }
  }, [rightAnswer]);

  if (!validateLoadContent(slug || '')) {
    return <Lock />;
  }
  
  return (
    <>
      {rightAnswer && user?.exerciseShowAnimation && (
        <Confetti
          width={window.innerWidth - 20}
          height={document.body.clientHeight}
          numberOfPieces={300}
        />
      )}
      <Container className='pb-0'>
        <Breadcrumbs items={breadcrumbItems} />
      </Container>
      <Exercise
        exercises={exercises}
        showExerciseNavigation={false}
        initialPage={initialPage}
        onPageChange={(page) => changeExercise(page)}
        showContentList={true}
        isLoading={isLoading}
        onClickContentList={() => {
          setIsContentModal(true);
        }}
        onExerciseChange={(exercise, action) => {
          updateExercise(exercise, action);
        }}
      />
      <ContentModal
        isOpen={isContentModal}
        onClose={() => setIsContentModal(false)}
        slug={slug || ''}
        subtitle={'Lista de Exercícios'}
        discipline={discipline || ''}
        module={module || ''}
        subject={subject || ''}
        initialContent={null}
        initialTab={1}
        contentType="exercicio"
      />
    </>
  );
};

export default ExercisePage;
